/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./ProfileNudge.css";

/**
 * "Your profile is 50% complete — 3 still unanswered", above the dashboard.
 *
 * From `Plug Marketplace v2.dc.html` in the Claude Design project (CP-319).
 * One card for every persona: the view model already varies what finishing
 * the questions is worth — being found, a shorter shortlist, a feed worth
 * opening — so nothing here has to know which account it is drawn for.
 *
 * Renders nothing when there is nothing to nudge about. profileNudgeVm returns
 * null once every question is answered, and on a section the design does not
 * put the banner on, so a finished profile is not congratulated for it.
 */
class ProfileNudge extends Component {
  render() {
    const nudge = this.props.nudge;
    if (!nudge) {
      return null;
    }
    return (
      <div className="Marketplace-ProfileNudge">
        <span className="Marketplace-ProfileNudge-mark">!</span>
        <div className="Marketplace-ProfileNudge-copy">
          <div className="Marketplace-ProfileNudge-title">{nudge.title}</div>
          <div className="Marketplace-ProfileNudge-body">{nudge.body}</div>
        </div>
        {/* The bar restates the figure rather than carrying it: the sentence
            above is what a screen reader announces, so this is decoration. */}
        <div className="Marketplace-ProfileNudge-bar" aria-hidden="true">
          <div
            className="Marketplace-ProfileNudge-barFill"
            style={{ width: nudge.barWidth }}
          />
        </div>
        <div className="Marketplace-ProfileNudge-cta" onClick={nudge.go}>
          {nudge.cta}
        </div>
      </div>
    );
  }
}

ProfileNudge.propTypes = {
  /* null when the profile is finished, or on a section without the banner. */
  nudge: PropTypes.object,
};

export default ProfileNudge;
